/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeCaseWinStatsDto,
  CaseOpeningAdminGetCaseWinStatsParams
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type caseOpeningAdminGetCaseWinStatsResponse200 = {
  data: ApiEnvelopeCaseWinStatsDto
  status: 200
}

export type caseOpeningAdminGetCaseWinStatsResponseSuccess = (caseOpeningAdminGetCaseWinStatsResponse200) & {
  headers: Headers;
};
;

export type caseOpeningAdminGetCaseWinStatsResponse = (caseOpeningAdminGetCaseWinStatsResponseSuccess)

export const getCaseOpeningAdminGetCaseWinStatsUrl = (params?: CaseOpeningAdminGetCaseWinStatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/caseopening/admin/stats?${stringifiedParams}` : `/api/caseopening/admin/stats`
}

export const useCaseOpeningAdminGetCaseWinStatsHook = (): (params?: CaseOpeningAdminGetCaseWinStatsParams, options?: RequestInit) => Promise<caseOpeningAdminGetCaseWinStatsResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: CaseOpeningAdminGetCaseWinStatsParams, options?: RequestInit) => {

        return customFetcher(getCaseOpeningAdminGetCaseWinStatsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


